// Плавное открытие/закрытие результатов поиска
const initSearchResults = () => {
  // Для десктопа ищем .header__actions-search, для мобилки .header__actions-search-mobile
  const isMobile = window.innerWidth <= 767;
  const selector = isMobile 
    ? '.header__actions-search-mobile input[type="text"]' 
    : '.header__actions-search input[type="text"]';
  const searchInputs = document.querySelectorAll(selector);
  if (!searchInputs.length) return;

  searchInputs.forEach((input) => {
    // Ищем контейнер - для десктопа .header__actions-search, для мобилки .header__actions-search-mobile
    const searchContainer = input.closest('.header__actions-search') || input.closest('.header__actions-search-mobile');
    const searchResults = searchContainer?.querySelector('.search-results');
    const resultsWrap = searchResults?.querySelector('.search-results__wrap');
    // Кнопка очистки только для десктопа
    const clearButton = searchContainer?.querySelector('.header__actions-search-button');
    if (!searchResults || !resultsWrap) return;

    let debounceTimer;
    let currentRequestController = null;

    const toggleSearchResults = (show) => {
      if (show) {
        searchResults.classList.add('is-open');
      } else {
        searchResults.classList.remove('is-open');
      }
    };

    const toggleClearButton = (show) => {
      if (!clearButton) return;
      if (show) {
        clearButton.classList.add('is-active');
      } else {
        clearButton.classList.remove('is-active');
      }
    };

    const renderProducts = (products) => {
      if (!products || products.length === 0) {
        resultsWrap.innerHTML = '<div class="search-results__empty">Товары не найдены</div>';
        // Скрываем кнопку, если нет результатов
        toggleClearButton(false);
        return;
      }

      resultsWrap.innerHTML = products.map(product => `
        <div class="search-results__item">
          <a href="${product.permalink}" class="search-results__item-link"></a>
          <div class="search-results__item-image">
            <img src="${product.image}" alt="${product.title}" loading="lazy">
          </div>
          <div class="search-results__item-content">
            <h3 class="search-results__item-title">${product.title}</h3>
            <p class="search-results__item-sku">${product.sku || ''}</p>
          </div>
        </div>
      `).join('');
      
      // Показываем кнопку, если есть результаты
      toggleClearButton(true);
    };

    const showLoading = () => {
      resultsWrap.innerHTML = '<div class="search-results__loading">Поиск...</div>';
    };

    const searchProducts = async (query) => {
      // Отменяем предыдущий запрос, если он еще выполняется
      if (currentRequestController) {
        currentRequestController.abort();
      }

      // Создаем новый AbortController для текущего запроса
      currentRequestController = new AbortController();

      showLoading();
      toggleSearchResults(true);
      // Показываем кнопку при загрузке (на десктопе)
      if (!isMobile) {
        toggleClearButton(true);
      }

      try {
        // Используем wp_ajax эндпоинт для поиска
        const formData = new URLSearchParams();
        formData.append('action', 'ns_search_products');
        formData.append('query', query);
        formData.append('limit', '10');

        const response = await fetch('/wp-admin/admin-ajax.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData.toString(),
          signal: currentRequestController.signal
        });

        const data = await response.json();

        if (data && data.success) {
          renderProducts(data.data.products);
        } else {
          resultsWrap.innerHTML = '<div class="search-results__empty">Ошибка поиска</div>';
          // Скрываем кнопку при ошибке
          toggleClearButton(false);
        }
      } catch (error) {
        // Игнорируем ошибку, если запрос был отменен
        if (error.name === 'AbortError') {
          return;
        }
        console.error('Search error:', error);
        resultsWrap.innerHTML = '<div class="search-results__empty">Ошибка поиска</div>';
        // Скрываем кнопку при ошибке
        toggleClearButton(false);
      } finally {
        currentRequestController = null;
      }
    };

    const handleInput = () => {
      clearTimeout(debounceTimer);
      const value = input.value.trim();
      
      // Если поле пустое, сразу скрываем результаты и кнопку
      if (value.length === 0) {
        toggleSearchResults(false);
        toggleClearButton(false);
        resultsWrap.innerHTML = '';
        // Отменяем запрос, если он выполняется
        if (currentRequestController) {
          currentRequestController.abort();
          currentRequestController = null;
        }
        return;
      }

      // Показываем кнопку при вводе (на десктопе)
      if (!isMobile) {
        toggleClearButton(true);
      }

      // Debounce для запроса - отправляем только после паузы в 500ms
      debounceTimer = setTimeout(() => {
        searchProducts(value);
      }, 500);
    };

    // Обработчик клика на кнопку очистки
    if (clearButton) {
      clearButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        input.value = '';
        input.focus();
        toggleSearchResults(false);
        toggleClearButton(false);
        resultsWrap.innerHTML = '';
        
        // Отменяем запрос, если он выполняется
        if (currentRequestController) {
          currentRequestController.abort();
          currentRequestController = null;
        }
        
        // Очищаем debounce таймер
        clearTimeout(debounceTimer);
      });
    }

    // Обработчик ввода
    input.addEventListener('input', handleInput);
    input.addEventListener('focus', () => {
      const value = input.value.trim();
      if (value.length > 0) {
        searchProducts(value);
      }
    });

    // Закрытие при клике вне области поиска
    document.addEventListener('click', (e) => {
      if (!searchContainer.contains(e.target)) {
        toggleSearchResults(false);
      }
    });

    // Закрытие при нажатии Escape
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        toggleSearchResults(false);
        input.blur();
      }
    });
  });
};

initSearchResults();

// Открытие мобильного поиска
const initMobileSearch = () => {
  const searchButton = document.querySelector('.header__mobile .header__actions-search-button');
  const mobileSearch = document.querySelector('.header__actions-search-mobile');
  
  if (!searchButton || !mobileSearch) return;

  searchButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const isOpen = mobileSearch.classList.contains('is-open');
    
    if (isOpen) {
      // Закрываем поиск
      mobileSearch.classList.remove('is-open');
      // Убираем фокус с input
      const input = mobileSearch.querySelector('input');
      if (input) {
        input.blur();
        input.value = '';
      }
    } else {
      // Открываем поиск
      mobileSearch.classList.add('is-open');
      // Фокусируемся на input
      const input = mobileSearch.querySelector('input');
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
    }
  });

  // Закрытие при клике на кнопку закрытия внутри мобильного поиска
  const closeButton = mobileSearch.querySelector('.header__actions-search-button-mobile');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (mobileSearch.querySelector('.search-results').classList.contains('is-open')) {
        mobileSearch.querySelector('.search-results').classList.remove('is-open');
      }
      
      mobileSearch.classList.remove('is-open');
      const input = mobileSearch.querySelector('input');
      if (input) {
        input.blur();
        input.value = '';
      }
    });
  }

  // Закрытие при клике вне области поиска
  document.addEventListener('click', (e) => {
    // Не закрываем поиск, если клик был на кнопке data-menu (она обрабатывается отдельно)
    const menuButton = document.querySelector('[data-menu]');
    if (menuButton && menuButton.contains(e.target)) {
      return;
    }
    
    if (!mobileSearch.contains(e.target) && !searchButton.contains(e.target)) {
      if (mobileSearch.classList.contains('is-open')) {
        mobileSearch.classList.remove('is-open');
        const input = mobileSearch.querySelector('input');
        if (input) {
          input.blur();
        }
      }
    }
  });
};

initMobileSearch();

export default initSearchResults;

